import React, { useEffect, useRef } from 'react'
import { ReadOnlyLexicalEditor } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/ReadOnlyLexicalEditor/ReadOnlyLexicalEditor'
import { LEXICAL_NODES } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'
import { LexicalEditor } from 'lexical'
import { $convertFromMarkdownString, TRANSFORMERS } from '@lexical/markdown'

export const MarkdownViewer: React.FC<{ markdown: string }> = ({ markdown }) => {
  const editorRef = useRef<LexicalEditor>(null)

  useEffect(() => {
    if (!editorRef.current) {
      return
    }
    editorRef.current.update(() => {
      $convertFromMarkdownString(markdown, TRANSFORMERS)
    })
  }, [editorRef, markdown])

  return <ReadOnlyLexicalEditor ref={editorRef} lexicalNodes={LEXICAL_NODES} />
}
